export const isString = (val: any) => val !== null && typeof val === 'string';
